import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-e0498bfa"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "holder holder-fluid"
};
const _hoisted_3 = {
  class: "line"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "Коллекция", -1));

const _hoisted_5 = {
  class: "line-right"
};
const _hoisted_6 = {
  class: "search"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "search-button"
}, null, -1));

const _hoisted_8 = {
  class: "catalog",
  ref: "catalog"
};
const _hoisted_9 = {
  key: 0,
  class: "pagination"
};
const _hoisted_10 = {
  class: "pagination-text"
};

const _hoisted_11 = /*#__PURE__*/_createTextVNode("Страница ");

const _hoisted_12 = {
  class: "pagination-list"
};
const _hoisted_13 = {
  class: "pagination-arrows"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_WorksFilterComponent = _resolveComponent("WorksFilterComponent");

  const _component_EmptyResultComponent = _resolveComponent("EmptyResultComponent");

  const _component_WorkCardComponent = _resolveComponent("WorkCardComponent");

  const _component_SpinnerComponent = _resolveComponent("SpinnerComponent");

  const _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("input", {
    type: "text",
    class: "search-input",
    placeholder: "Поиск",
    onChange: _cache[0] || (_cache[0] = $event => $data.search = $event.target.value)
  }, null, 32), _hoisted_7]), _createVNode(_component_WorksFilterComponent, {
    onFiltered: _cache[1] || (_cache[1] = (authorIds, years) => $options.filterWorks(authorIds, years))
  })])]), _createElementVNode("div", _hoisted_8, [$data.worksLoader.load && !$data.Works.length ? (_openBlock(), _createBlock(_component_EmptyResultComponent, {
    key: 0,
    title: $data.worksLoader.title,
    description: $data.worksLoader.description
  }, null, 8, ["title", "description"])) : _createCommentVNode("", true), _createVNode(_component_WorkCardComponent, {
    works: $data.Works
  }, null, 8, ["works"])], 512), _withDirectives(_createVNode(_component_SpinnerComponent, null, null, 512), [[_vShow, !$data.worksLoader.load]]), $data.PaginationMeta && $data.PaginationMeta.pageCount ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("b", null, _toDisplayString($data.PaginationMeta.currentPage), 1), _createTextVNode(" из " + _toDisplayString($data.PaginationMeta.pageCount), 1)]), _createElementVNode("ul", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.PaginationMeta.pageCount, number => {
    return _openBlock(), _createElementBlock("li", {
      key: 'numberPage-' + number
    }, [_createVNode(_component_router_link, {
      to: {
        name: 'works',
        query: {
          page: number
        }
      },
      class: _normalizeClass({
        'active': number === $data.PaginationMeta.currentPage
      })
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(number), 1)]),
      _: 2
    }, 1032, ["to", "class"])]);
  }), 128))]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_router_link, {
    to: {
      name: 'works',
      query: {
        page: $data.PaginationMeta.currentPage - 1
      }
    },
    class: "pagination-prev"
  }, null, 8, ["to"]), _createVNode(_component_router_link, {
    to: {
      name: 'works',
      query: {
        page: $data.PaginationMeta.currentPage + 1
      }
    },
    class: "pagination-next"
  }, null, 8, ["to"])])], 512)), [[_vShow, false]]) : _createCommentVNode("", true)])]);
}